"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("../../../../../theme/styled-components"));
exports["default"] = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  max-width: 100%;\n  iframe,\n  span {\n    max-width: 100%;\n  }\n"], ["\n  width: 100%;\n  max-width: 100%;\n  iframe,\n  span {\n    max-width: 100%;\n  }\n"])));
var templateObject_1;
